import { Form, Input, Button } from 'antd';
import { AxiosError } from 'axios';
import IMeasurementUnitDTO from '../../../../dtos/IMeasurementUnitDTO';
import { useApi } from '../../../../hooks/api';
import { useNotification } from '../../../../hooks/notification';
import { Container } from './styles';

const validate = {
  required: '${label} é obrigatório',
};

const NewMaterialTypes: React.FC = () => {
  const { api } = useApi();
  const { openNotificationWithIcon } = useNotification();
  const [form] = Form.useForm();

  const handleSubmit = async (data: IMeasurementUnitDTO): Promise<void> => {
    try {
      await api.post('materialTypes', data);
      openNotificationWithIcon('success', {
        title: 'Tipo de material',
        content: 'Tipo de material cadastrado com sucesso!',
      });
      form.resetFields();
    } catch (error) {
      let errorMessage;
      if (error instanceof AxiosError) {
        errorMessage = error?.response?.data.messageResponse;
      }
      openNotificationWithIcon('error', {
        title: 'Tipo de material',
        content: errorMessage || 'Erro ao cadastrar a tipo de material!',
      });
    }
  };

  return (
    <Container>
      <h1>Cadastro de Tipos de Material</h1>
      <Form
        size="large"
        labelCol={{ flex: '110px' }}
        labelAlign="left"
        wrapperCol={{ flex: 1 }}
        labelWrap
        colon={false}
        validateMessages={validate}
        onFinish={handleSubmit}
        form={form}
      >
        <Form.Item
          name={['name']}
          label="Nome"
          rules={[{ required: true }]}
          wrapperCol={{ span: 12 }}
          hasFeedback
        >
          <Input />
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Salvar
        </Button>
      </Form>
    </Container>
  );
};

export default NewMaterialTypes;
